import React, { Component } from "react";
import { Typography, Select, MenuItem, TextField } from "@material-ui/core";
import ComponentTemplate from "../../../Utilities/TemplateWrappers/ComponentTemplate";

import _ from "lodash";
import { getUsers, getAreas, getDepartments } from "./actions";
import { connect } from "react-redux";

class JobPackAssigneesArrayList extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getAreas();
        props.getDepartments();
        this.state = { profile: props.profile, edit: props.edit };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }

    renderText = (label, key, multiline = false) => {
        if (this.state.edit) {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: "21px",
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{ width: 156, color: "#0188cc" }}
                    >
                        <b>{label}:</b>
                    </Typography>
                    <TextField
                        rows={multiline ? 2 : 1}
                        rowsMax={multiline ? 4 : 1}
                        multiline={multiline}
                        style={{ width: "55%" }}
                        value={this.state.profile[key] || ""}
                        onChange={(event) => {
                            this.props.callback(key, event.target.value);
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: "21px",
                    }}
                >
                    <Typography
                        style={{ width: 200, color: "#0188cc" }}
                        variant="h6"
                    >
                        <b>{label}:</b>
                    </Typography>
                    <Typography
                        style={{ maxWidth: "200px", wordBreak: "break-word" }}
                        variant="subtitle2"
                    >
                        {this.state.profile[key]}
                    </Typography>
                </div>
            );
        }
    };

    renderDropdown = (label, key, opts, multiselect = false) => {
        const { profile } = this.state;
        if (this.state.edit) {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: "19px",
                    }}
                >
                    <Typography
                        style={{ width: 200, color: "#0188cc" }}
                        variant="h6"
                    >
                        <b>{label}:</b>
                    </Typography>
                    <Select
                        style={{ width: "50%" }}
                        value={
                            multiselect && profile[key]
                                ? profile[key].map((e) => {
                                      return _.get(e, "uid") || null;
                                  })
                                : !multiselect && profile[key]
                                ? profile[key]
                                : []
                        }
                        multiple={multiselect}
                        onChange={(event) => {
                            if (multiselect) {
                                let newArray = _.flattenDeep(
                                    _.compact(
                                        event.target.value.map((e) => {
                                            return _.compact(
                                                opts.map((f) => {
                                                    if (e === f.uid) {
                                                        return f;
                                                    } else return false;
                                                })
                                            );
                                        })
                                    )
                                );
                                this.props.callback(key, newArray);
                            } else this.props.callback(key, event.target.value);
                        }}
                    >
                        {opts.map((e) => {
                            return (
                                <MenuItem
                                    key={e.uid}
                                    value={multiselect ? e.uid : e.user_name}
                                >
                                    {e.user_name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: "19px",
                    }}
                >
                    <Typography
                        style={{ width: 200, color: "#0188cc" }}
                        variant="h6"
                    >
                        <b>{label}:</b>
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        style={{
                            maxWidth: "220px",
                            wordBreak: "break-word",
                            marginTop: "7px",
                        }}
                    >
                        {Array.isArray(this.state.profile[key])
                            ? this.state.profile[key].map((e) => {
                                  return `${e.user_name} , `;
                              })
                            : this.state.profile[key]}
                    </Typography>
                </div>
            );
        }
    };
    renderDropdownV2 = (label, key, opts) => {
        const { profile } = this.state;
        if (this.state.edit) {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: "19px",
                    }}
                >
                    <Typography
                        style={{ width: 200, color: "#0188cc" }}
                        variant="h6"
                    >
                        <b>{label}:</b>
                    </Typography>
                    <Select
                        style={{ width: "50%" }}
                        value={
                            typeof profile[key] === "undefined"
                                ? ""
                                : profile[key].uid
                        }
                        onChange={(event) => {
                            let User = null;
                            opts.map((f) => {
                                if (event.target.value === f.uid) {
                                    User = f;
                                }
                                return null;
                            });

                            if (User) this.props.callback(key, User);
                        }}
                    >
                        {opts.map((e) => {
                            return (
                                <MenuItem key={e.uid} value={e.uid}>
                                    {e.user_name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: "19px",
                    }}
                >
                    <Typography
                        style={{ width: 200, color: "#0188cc" }}
                        variant="h6"
                    >
                        <b>{label}:</b>
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        style={{
                            maxWidth: "220px",
                            wordBreak: "break-word",
                            marginTop: "7px",
                        }}
                    >
                        {Array.isArray(this.state.profile[key])
                            ? this.state.profile[key].map((e) => {
                                  return `${e.user_name} , `;
                              })
                            : typeof this.state.profile[key] === "undefined"
                            ? null
                            : this.state.profile[key].user_name}
                    </Typography>
                </div>
            );
        }
    };
    render() {
        const { users } = this.props;
        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={true}
                label="Assigned Crew"
            >
                {users && (
                    <>
                        {this.renderDropdown(
                            "Assigned Manager",
                            "assigned_manager",
                            users,
                            false
                        )}
                        {this.renderDropdownV2(
                            "Assigned Supervisor",
                            "assigned_supervisor",
                            users,
                            false
                        )}
                        {this.renderDropdown(
                            "Assigned Operatives",
                            "assigned_operatives",
                            users,
                            true
                        )}
                        {this.renderText(
                            "Extra Operatives",
                            "extra_operatives"
                        )}
                    </>
                )}
            </ComponentTemplate>
        );
    }
}
export default connect(
    (store, props) => {
        const { selectors } = props;
        const {
            selectUserInfo,
            selectDept,
            selectAreas,
            selectAllDepartments,
            selectAllAreas,
        } = selectors;
        return {
            users: selectUserInfo(store),
            profileDepts: selectDept(store),
            profileAreas: selectAreas(store),
            allDepartments: selectAllDepartments(store),
            allAreas: selectAllAreas(store),
        };
    },
    { getUsers, getAreas, getDepartments }
)(JobPackAssigneesArrayList);
